import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";
import { resolveItemImage, resolveMediaUrl } from "../utils/media";
import gallery1 from "../assets/gallery-1.jpeg";
// import gallery2 from "../assets/gallery-2.jpeg";
// import gallery3 from "../assets/gallery-3.jpeg";
import Image1 from "../assets/Image-1.jpeg";
import image2 from "../assets/Image-1.jpeg";
import image3 from "../assets/Image-1.jpeg";
import testimonial1 from "../assets/M A Malony.jpeg";
import testimonial2 from "../assets/secretary.jpeg";
import testimonial3 from "../assets/WhatsApp Image 2026-02-16 at 14.46.15.jpeg";
import teamImage1 from "../assets/M A Malony.jpeg";
import teamImage2 from "../assets/secretary.jpeg";
import teamImage3 from "../assets/WhatsApp Image 2026-02-16 at 14.46.14.jpeg";
import teamImage4 from "../assets/WhatsApp Image 2026-02-16 at 14.46.15.jpeg";
import teamImage5 from "../assets/WhatsApp Image 2026-02-16 at 14.46.15 (1).jpeg";
import teamImage6 from "../assets/WhatsApp Image 2026-02-16 at 14.46.15 (2).jpeg";
import teamImage7 from "../assets/gallery-3.jpeg";

const fallbackTeam = [
  {
    name: "M.A. Malony",
    role: "Founder and Executive Director",
    initials: "MM",
    copy: "Leads the vision for early learning, equity, and community care."
  }
 
];

const fallbackPartners = [
  { name: "Amala", mark: "AM", link: "", logo_url: "" },
  { name: "Faulu", mark: "FA", link: "", logo_url: "" },
  { name: "AReL", mark: "AR", link: "", logo_url: "" },
  { name: "UNHCR", mark: "UN", link: "https://www.unhcr.org/", logo_url: "" },
  { name: "LWF", mark: "LW", link: "", logo_url: "" },
  { name: "JRS", mark: "JR", link: "", logo_url: "" }
];

const fallbackTestimonials = [
  {
    name: "M.A. Malony",
    role: "Founder, EUTR",
    image: testimonial1,
    quote:
      "Our mission is practical: start early, protect learning, and ensure every child in Kakuma is ready to thrive."
  },
  {
    name: "Linet Achieng",
    role: "Education Lead",
    image: testimonial2,
    quote:
      "When children receive foundational support, their confidence grows, attendance improves, and families stay hopeful."
  },
  {
    name: "Community Parent Leader",
    role: "Parent Representative",
    image: testimonial3,
    quote:
      "EUTR gives our children structure and joy. The vision is visible in every classroom and every parent meeting."
  }
];

const normalizeTeam = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

const normalizeTestimonials = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

const normalizePartners = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

const resolveImage = resolveMediaUrl;

const teamImages = [
  teamImage1,
  teamImage2,
  teamImage3,
  teamImage4,
  teamImage5,
  teamImage6,
  teamImage7
];

function HumanAvatar({ gender }) {
  return (
    <svg className="human-avatar-svg" viewBox="0 0 120 160" role="img" aria-label={`${gender || "neutral"} profile avatar`}>
      <circle className="human-avatar-head" cx="60" cy="42" r="25" />
      {gender === "female" && <path className="human-avatar-hair" d="M35 43c1-27 48-35 51 1v24H77V48c-12 8-26 8-40 0v20H35V43z" />}
      {gender === "male" && <path className="human-avatar-hair" d="M36 39c3-28 46-31 49 1-12-8-27-10-49-1z" />}
      <path className="human-avatar-body" d="M18 151c2-35 18-53 42-53s40 18 42 53H18z" />
    </svg>
  );
}

function About() {
  const [team, setTeam] = useState(fallbackTeam);
  const [expandedMembers, setExpandedMembers] = useState({});
  const [teamLoading, setTeamLoading] = useState(true);
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);
  const [testimonialsLoading, setTestimonialsLoading] = useState(true);
  const [partners, setPartners] = useState(fallbackPartners);
  const [partnersLoading, setPartnersLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadTeam = async () => {
      try {
        const response = await fetch(getApiUrl("/api/team/"));
        if (!response.ok) throw new Error("Failed to load team");
        const data = await response.json();
        const normalized = normalizeTeam(data);
        if (isMounted && normalized.length) {
          setTeam(normalized);
        }
      } catch (error) {
        if (isMounted) {
          setTeam(fallbackTeam);
        }
      } finally {
        if (isMounted) {
          setTeamLoading(false);
        }
      }
    };

    loadTeam();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadPartners = async () => {
      try {
        const response = await fetch(getApiUrl("/api/partners/"));
        if (!response.ok) throw new Error("Failed to load partners");
        const data = await response.json();
        const normalized = normalizePartners(data);
        if (isMounted && normalized.length) {
          setPartners(
            normalized.map((item) => ({
              name: item?.name || "Partner",
              link: item?.link || "",
              logo_url: resolveItemImage(item, ["logo_url", "logo", "image"]),
              mark:
                (item?.name || "PT")
                  .split(" ")
                  .map((part) => part[0])
                  .join("")
                  .slice(0, 2)
                  .toUpperCase() || "PT"
            }))
          );
        }
      } catch (error) {
        if (isMounted) {
          setPartners(fallbackPartners);
        }
      } finally {
        if (isMounted) {
          setPartnersLoading(false);
        }
      }
    };

    loadPartners();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadTestimonials = async () => {
      try {
        const response = await fetch(getApiUrl("/api/testimonials/"));
        if (!response.ok) throw new Error("Failed to load testimonials");
        const data = await response.json();
        const normalized = normalizeTestimonials(data);
        if (isMounted && normalized.length) {
          setTestimonials(
            normalized.map((item, index) => ({
              name: item?.name || item?.full_name || "Community Member",
              role: item?.role || item?.title || "Community Voice",
              image: resolveItemImage(item) || teamImages[index % teamImages.length],
              quote: item?.quote || item?.message || item?.testimonial || ""
            }))
          );
        }
      } catch (error) {
        if (isMounted) {
          setTestimonials(fallbackTestimonials);
        }
      } finally {
        if (isMounted) {
          setTestimonialsLoading(false);
        }
      }
    };

    loadTestimonials();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <section className="hero about-hero">
        <img className="hero-bg" src={image2} alt="EUTR children learning together" />
        <div className="container hero-content">
          <div className="row align-items-center gy-4">
            <div className="col-lg-7 section-reveal">
              <h1 className="hero-title fw-bold">About Us</h1>
              <p className="hero-copy mb-0">
                We exist to build strong educational foundations for children and
                create resilient, united communities in Kakuma.
              </p>
            </div>
            <div className="col-lg-5 section-reveal delay-1">
              <div className="hero-card">
                <h5>What we believe</h5>
                <p className="text-muted mb-0">
                  Strong foundations in early childhood education unlock lifelong
                  success. We build learning programs that inspire curiosity,
                  unity, and mutual respect.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <img
                src={image3}
                alt="Teacher guiding children in a classroom"
                style={{ borderRadius: "28px", border: "1px solid var(--border)" }}
              />
            </div>
            <div className="col-lg-6">
              <div className="section-title">Our Story</div>
              <h2 className="section-heading">Born from a passion for change.</h2>
              <p className="section-copy">
                Educate Us to Rise grew out of the challenges we witnessed every
                day: overcrowded classrooms, limited learning materials, and
                declining performance. We chose to act, building strong
                foundations before children enter primary school.
              </p>
              <ul className="list-unstyled text-muted">
                <li className="mb-2">Early learning support for ages 3 and above.</li>
                <li className="mb-2">Programs serving refugee and host communities.</li>
                <li className="mb-2">Community-led leadership and accountability.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-tight" aria-label="Children learning in the classroom">
        <div className="container">
          <div className="section-title">Learning in action</div>
          <h2 className="section-heading mb-4">Real classrooms. Real opportunity.</h2>
          <div className="row gy-4">
            {[Image1, image2, image3].map((image, index) => (
              <div className="col-md-4" key={image}>
                <img
                  src={image3}
                  alt={`Children learning in the classroom ${index + 1}`}
                  style={{ height: "240px", width: "100%", objectFit: "cover", borderRadius: "24px", border: "1px solid var(--border)" }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-tight">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="glow-card">
                <div className="section-title">Mission</div>
                <h3>Build strong foundations for every child.</h3>
                <p className="text-muted mb-0">
                  To empower refugee communities through education, skills
                  development, peacebuilding, women&apos;s empowerment, and
                  community-led initiatives that promote resilience and
                  self-reliance.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="glow-card">
                <div className="section-title">Vision</div>
                <h3>A living society built on profitable knowledge.</h3>
                <p className="text-muted mb-0">
                  To re-create a living society where individuals have
                  profitable knowledge that can benefit the society.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-tight">
        <div className="container">
          <div className="section-title">Our Partners</div>
          <h2 className="section-heading mb-4">
            Collaboration that strengthens our impact.
          </h2>
          {partnersLoading && (
            <p className="text-muted mb-3">Loading partners...</p>
          )}
          <div className="row gy-3">
            {partners.map((partner, index) => {
              const card = (
                <div className="partner-card">
                  {partner.logo_url ? (
                    <img
                      src={partner.logo_url}
                      alt={`${partner.name} logo`}
                      style={{
                        width: "56px",
                        height: "56px",
                        borderRadius: "14px",
                        objectFit: "cover",
                        marginBottom: "0.75rem"
                      }}
                    />
                  ) : (
                    <div className="partner-logo" aria-label={`${partner.name} logo`}>
                      {partner.mark || partner.name.slice(0, 2).toUpperCase()}
                    </div>
                  )}
                  <p className="mb-0 fw-semibold">{partner.name}</p>
                </div>
              );

              return (
                <div className="col-6 col-md-4 col-lg-2" key={`${partner.name}-${index}`}>
                  {partner.link ? (
                    <a href={partner.link} target="_blank" rel="noreferrer" className="text-decoration-none text-reset">
                      {card}
                    </a>
                  ) : (
                    card
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <img
                src={gallery1}
                alt="Learners in class"
                style={{ borderRadius: "28px", border: "1px solid var(--border)" }}
              />
            </div>
            <div className="col-lg-6">
              <div className="section-title">How We Deliver</div>
              <h2 className="section-heading">Three ways we drive mission to vision.</h2>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <h5 className="mb-1">1. School Readiness</h5>
                  <p className="text-muted mb-0">
                    Safe and structured learning for young children before they
                    transition to primary school.
                  </p>
                </li>
                <li className="mb-3">
                  <h5 className="mb-1">2. Family and Community Partnership</h5>
                  <p className="text-muted mb-0">
                    Parent engagement, referral support, and local leadership to
                    sustain children&apos;s learning.
                  </p>
                </li>
                <li>
                  <h5 className="mb-1">3. Protection and Opportunity</h5>
                  <p className="text-muted mb-0">
                    Child protection, gender-responsive programs, and practical
                    pathways that strengthen dignity and livelihoods.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-tight">
        <div className="container">
          <div className="section-title">Testimonials</div>
          <h2 className="section-heading mb-4">Voices from our community.</h2>
          {testimonialsLoading && (
            <p className="text-muted mb-3">Loading testimonials...</p>
          )}
          <div className="row gy-4">
            {testimonials.map((item) => (
              <div className="col-lg-4" key={item.name}>
                <div className="testimonial-card">
                  <img
                    className="testimonial-image"
                    src={resolveImage(item.image) || teamImages[0]}
                    alt={`${item.name} testimonial`}
                  />
                  <p className="text-muted fst-italic mt-3 mb-3">&quot;{item.quote}&quot;</p>
                  <h6 className="mb-1">{item.name}</h6>
                  <small className="text-muted">{item.role}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-tight">
        <div className="container">
          <div className="section-reveal">
            <div className="section-title">Our Team</div>
            <h2 className="section-heading">Neighbors leading the work.</h2>
            <p className="section-copy mb-4">
              Our team blends lived experience with professional expertise to
              keep children learning and families supported.
            </p>
            {teamLoading && (
              <p className="text-muted">Loading team members...</p>
            )}
          </div>
          <div className="row gy-3 section-reveal delay-1">
            {team.map((member, index) => (
              <div className="col-md-6 col-lg-4" key={member.name}>
                <div className="team-card">
                  {(() => {
                    const image = resolveItemImage(member);
                    return image ? (
                      <img className="team-photo" src={image} alt={member.name} />
                    ) : (
                      <div className={`team-photo team-avatar team-avatar-${member.gender || "neutral"}`} aria-label={`${member.name} avatar`}>
                        <HumanAvatar gender={member.gender} />
                      </div>
                    );
                  })()}
                  <div className="team-card-body">
                    <div className="team-card-kicker">Team member</div>
                    <h5 className="mb-1">{member.name}</h5>
                    <div className="text-muted mb-2">{member.role}</div>
                    <p className={`text-muted team-bio ${expandedMembers[member.name] ? "team-bio-expanded" : ""}`}>
                      {member.copy || member.bio || member.description}
                    </p>
                    {(member.copy || member.bio || member.description || "").length > 150 && (
                      <button className="team-more-button" type="button" onClick={() => setExpandedMembers((current) => ({ ...current, [member.name]: !current[member.name] }))}>
                        {expandedMembers[member.name] ? "Less" : "More"}
                      </button>
                    )}
                    {member.linkedin && <a className="team-linkedin" href={member.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
